import { analyzerChanged } from './analyzerSlice';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import { Analyzer } from 'types';
import { useAppDispatch } from '../../app/hooks';

interface Props {
  analyzers: Analyzer[] | undefined;
  selectedAnalyzerId: number | null;
  fullWidth?: boolean;
}

const AnalyzerSelect = ({
  analyzers,
  selectedAnalyzerId,
  fullWidth = false,
}: Props) => {
  const dispatch = useAppDispatch();

  const handleChange = (event: SelectChangeEvent<number>) => {
    const analyzerId = event.target.value;
    dispatch(analyzerChanged(analyzerId));
  };

  return (
    <FormControl variant='outlined' sx={{ minWidth: 90 }} fullWidth={fullWidth}>
      <InputLabel id='analyzer-select-label'>Analyzer</InputLabel>
      <Select
        labelId='analyzer-select-label'
        id='analyzer-select'
        name='analyzer'
        label='Analyzer'
        value={selectedAnalyzerId === null ? undefined : selectedAnalyzerId}
        onChange={handleChange}
        placeholder='None'
      >
        <MenuItem value={-1}>
          <em>None</em>
        </MenuItem>
        {analyzers?.map((analyzer) => {
          return (
            <MenuItem key={analyzer.id} value={analyzer.id}>
              {analyzer.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default AnalyzerSelect;
